module.exports = __webpack_public_path__ + "static/media/linkedin.824ff579.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/linkedin.svg
// module id = 30
// module chunks = 0